<template>
  <div>
    <quill-editor ref="quill" :options="options" />
    <div class="footer" >
      <el-button @click="$emit('cancel')" type="warning" icon="el-icon-close" >
        Annuler
      </el-button>
      <el-button @click="$emit('save', getStyleText())" type="success" icon="el-icon-check" >
        Valider
      </el-button>
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'highlight.js/styles/monokai-sublime.css'
import Quill from 'quill'
import {quillEditor} from 'vue-quill-editor'
import HighLightedBlockModule from '@/extra/HighLightedBlockModule'

Quill.register('modules/highlighted', HighLightedBlockModule)

export default {
  props: {
    contract: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      options: {
        modules: {
          highlighted: {
            language: 'css'
          },
          toolbar: false
        }
      }
    }
  },
  mounted () {
    this.setText()
  },
  watch: {
    contract () {
      this.setText()
    }
  },
  methods: {
    getStyleText () {
      return this.$refs.quill.quill.container.firstChild.textContent
    },
    setText () {
      this.$refs.quill.quill.setText(this.contract.style ? this.contract.style : '')
    }
  },
  components: {
    quillEditor
  }
}
</script>

<style scoped>
.quill-editor {
    height: 400px;
    background-color: #23241f;
}
.quill-editor >>> .ql-editor {
    padding: 0;
}
.quill-editor >>> .ql-syntax {
    margin: 0;
    border-radius: 0;
}
.footer {
    text-align: right;
    margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/contracts/components/ContractStyle.vue